import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import { ApiClientError } from '../../api/client';

/** Renders an error in the interface's voice — says what happened and how to retry. */
export function ErrorPanel({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const isApi = error instanceof ApiClientError;
  const title =
    isApi && error.status === 403
      ? 'You do not have access to this'
      : isApi && error.status === 404
        ? 'Not found'
        : 'Something went wrong';
  const message = error instanceof Error ? error.message : 'An unexpected error occurred.';
  return (
    <Box sx={{ p: 2 }}>
      <Alert
        severity={isApi && error.status === 403 ? 'warning' : 'error'}
        action={
          onRetry ? (
            <Button color="inherit" size="small" onClick={onRetry}>
              Retry
            </Button>
          ) : undefined
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {message}
        {isApi && error.correlationId && (
          <Typography variant="caption" display="block" sx={{ mt: 0.5, fontFamily: 'var(--mono)' }}>
            Correlation ID: {error.correlationId}
          </Typography>
        )}
      </Alert>
    </Box>
  );
}
